import React, { FunctionComponent } from 'react';

/**
 * Cancel Circle Icon
 */
const CancelCircleIcon: FunctionComponent<React.PropsWithChildren<{ color?: string }>> = ({
  color = '#DC4F4F'
}) => {
  return (
    <svg width="16" height="16" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.50016 0.333496C3.8135 0.333496 0.833496 3.3135 0.833496 7.00016C0.833496 10.6868 3.8135 13.6668 7.50016 13.6668C11.1868 13.6668 14.1668 10.6868 14.1668 7.00016C14.1668 3.3135 11.1868 0.333496 7.50016 0.333496ZM7.50016 12.3335C4.56016 12.3335 2.16683 9.94016 2.16683 7.00016C2.16683 4.06016 4.56016 1.66683 7.50016 1.66683C10.4402 1.66683 12.8335 4.06016 12.8335 7.00016C12.8335 9.94016 10.4402 12.3335 7.50016 12.3335ZM7.50016 6.06016L9.8935 3.66683L10.8335 4.60683L8.44016 7.00016L10.8335 9.3935L9.8935 10.3335L7.50016 7.94016L5.10683 10.3335L4.16683 9.3935L6.56016 7.00016L4.16683 4.60683L5.10683 3.66683L7.50016 6.06016Z"
        fill={color}
      />
    </svg>
  );
};

export default CancelCircleIcon;
